import { render, staticRenderFns } from "./editmessageconfig.vue?vue&type=template&id=2bcd0916&"
import script from "./editmessageconfig.vue?vue&type=script&lang=ts&"
export * from "./editmessageconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editmessageconfig.vue"
export default component.exports